import { GDPRPromise } from "@mp-commons/modules/ads/GDPR.js";
import { UserAdsData } from "@mp-commons/modules/ads/adcall/composable/UserAdsData.js";
import { AmazonBidBehaviour, AmazonBidder } from "@mp-commons/modules/ads/prebid/AmazonBidder.js";
import { IASHB } from "@mp-commons/modules/ads/prebid/IASHB.js";
import { GroupedPrebidModulesWithAdsManagerPostOps } from "@mp-commons/modules/ads/prebid/GroupedPrebidModules.js";
import { PrebidModule } from "@mp-commons/modules/ads/prebid/PrebidModule.js";
import { PrebidJS } from "@mp-commons/modules/ads/prebid/PrebidJS.js";
import { PianoModule } from "@mp-commons/modules/ads/prebid/PianoModule.js";
import { CP_AdvSiteName } from "@mp-commons/modules/ads/adcall/CustomParams.js";


//3597
export function PrebidBuilder(window: Window,userData: UserAdsData, amz?:{ pubId: string, behaviour: AmazonBidBehaviour }, iasIds?: { pubId: string, anId: string}, 
    prebidjs?: {enabled: boolean, site: CP_AdvSiteName},
    piano?: {enabled: boolean}, timeout: number = 1000): PrebidModule {

    const gdpr = GDPRPromise();

    const grouped = new GroupedPrebidModulesWithAdsManagerPostOps();
   
    if(amz?.pubId && amz.pubId != "") {
        const a9 = new AmazonBidder(timeout,amz.pubId,userData,window,amz.behaviour,gdpr);       
        grouped.addModule(a9);
        if(amz.behaviour == AmazonBidBehaviour.ALLOW_PRELOADING_NEXT_BID) {
            setTimeout(() => {
                a9.preloadNextBid();
            },0)
        }
    }
   
    if(iasIds && iasIds.pubId != "" && iasIds.anId != "") {
        //const ias = new IASHB(window,"930840","931226",timeout);
        const ias = new IASHB(window,iasIds.pubId,iasIds.anId,timeout);
        grouped.addModule(ias);
    }

    if(prebidjs && prebidjs.enabled) {
        const prebidjsModule = new PrebidJS(prebidjs.site, window, userData, gdpr)
        grouped.addModule(prebidjsModule)
    }


    if(piano && piano.enabled) {
        const pianoModule = new PianoModule(window)
        grouped.addModule(pianoModule)
    }

    return grouped;
}